export default function ApechainIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.604492" y="0.255859" width="36" height="36" rx="18" fill="#0054FA" />
            <path
                d="M9.54893 12.3111H11.9757L13.5408 25.3242H11.4833L11.2547 22.493H10.1644L9.9358 25.3242H7.98384L9.54893 12.3111ZM10.5161 18.0967L10.3051 20.7696H11.114L10.8854 18.0967L10.7271 15.8458H10.6744L10.5161 18.0967ZM17.853 25.3242H15.7604V12.3111H18.5037C19.9984 12.3111 20.9128 13.1904 20.9128 14.7731V17.9736C20.9128 19.5387 19.9984 20.4179 18.5037 20.4179H17.853V25.3242ZM17.8706 18.8529H18.3278C18.6795 18.8529 18.8202 18.5363 18.8202 17.9736V14.7731C18.8202 14.1928 18.6795 13.8762 18.3278 13.8762H17.8706V18.8529ZM23.3234 25.3242V12.3111H27.4032V14.0345H25.416V17.8857H27.1921V19.609H25.416V23.6009H27.4032V25.3242H23.3234Z"
                fill="white"
            />
        </svg>
    );
}
